<template>
  <div>
    <div class="breadcrumb">
      <span>高校管理</span>
      <span class="sep">/</span>
      <span>运动会统计</span>
    </div>

    <div class="content-wrapper" style="padding: 15px">
      <!-- 筛选条件 -->
      <div class="filter-bar">
        <el-select
          v-model="queryParam.provinceId"
          placeholder="请选择省份"
          clearable
          style="width: 160px"
          @change="onProvinceChange"
        >
          <el-option
            v-for="p in provinceOptions"
            :key="p.id"
            :label="p.name"
            :value="p.id"
          ></el-option>
        </el-select>

        <el-select
          no-data-text="请先选择省份"
          v-model="queryParam.cityId"
          :placeholder="queryParam.provinceId ? '请选择市区' : '请先选择省份'"
          clearable
          style="width: 160px"
        >
          <el-option
            v-for="c in cityOptions"
            :key="c.id"
            :label="c.name"
            :value="c.id"
          ></el-option>
        </el-select>

        <el-select
          v-model="queryParam.isSigned"
          placeholder="是否签约"
          clearable
          style="width: 140px"
        >
          <el-option label="未签约" :value="0"></el-option>
          <el-option label="签约" :value="1"></el-option>
          <el-option label="意向签约" :value="2"></el-option>
        </el-select>

        <el-select
          v-model="queryParam.schoolType"
          placeholder="学校类型"
          clearable
          style="width: 140px"
        >
          <el-option label="大学" :value="1"></el-option>
          <el-option label="高中" :value="4"></el-option>
        </el-select>

        <el-input
          v-model="queryParam.schoolName"
          placeholder="请输入学校名称"
          style="width: 200px"
          @keyup.enter.native="queryList"
        ></el-input>

        <el-button type="primary" @click="queryList">查询</el-button>
        <el-button @click="resetForm">重置</el-button>

        <el-button
          type="primary"
          plain
          class="export-btn"
          :loading="exporting"
          @click="exportExcel"
          >导出</el-button
        >
      </div>

      <!-- 列表 -->
      <el-table
        :data="listData"
        v-loading="loading"
        border
        height="ss"
        style="width: 100%; height: 60vh; margin-top: 12px"
      >
        <el-table-column label="序号" min-width="64" align="center">
          <template scope="scope">
            {{
              (queryParam.pageNum - 1) * queryParam.pageSize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column prop="province" label="所属省" min-width="80">
          <template scope="{ row }">{{
            provinceCodeMap[row.province] || row.province || "--"
          }}</template>
        </el-table-column>
        <el-table-column prop="city" label="所属市" min-width="80">
          <template scope="{ row }">{{
            cityCodeMap[row.city] || row.city || "--"
          }}</template>
        </el-table-column>
        <el-table-column prop="schoolName" label="学校" min-width="140">
          <template scope="{ row }">{{ row.schoolName || "--" }}</template>
        </el-table-column>
        <el-table-column prop="schoolTypeName" label="类型" width="90">
          <template scope="{ row }">{{ row.schoolTypeName || "--" }}</template>
        </el-table-column>
        <el-table-column prop="isSignedName" label="是否签约" width="100">
          <template scope="{ row }">{{ row.isSignedName || "--" }}</template>
        </el-table-column>
        <el-table-column
          prop="sportsMeetName"
          label="运动会名称"
          min-width="140"
        >
          <template scope="{ row }">{{ row.sportsMeetName || "--" }}</template>
        </el-table-column>
        <el-table-column
          prop="participantStudentCount"
          label="参与人数"
          width="100"
          align="right"
        >
          <template scope="{ row }">{{ row.participantStudentCount }}</template>
        </el-table-column>
        <el-table-column
          prop="participantCollegeCount"
          label="参与学院数"
          width="110"
          align="right"
        >
          <template scope="{ row }">{{ row.participantCollegeCount }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="报名结束时间" min-width="150">
          <template scope="{ row }">{{
            formatTimestamp(row.endTime)
          }}</template>
        </el-table-column>
        <el-table-column prop="holdTime" label="举办时间" min-width="160">
          <template scope="{ row }">{{ row.holdTime || "--" }}</template>
        </el-table-column>
      </el-table>

      <div class="pager" v-if="totalCount > 0">
        <el-pagination
          @current-change="changeCurrentPage"
          :current-page="queryParam.pageNum"
          :page-size="queryParam.pageSize"
          :total="totalCount"
          layout="total, prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SportsStatistic",
  data() {
    return {
      queryParam: {
        provinceId: "", // 省份 id（region），用于拉市区 + 取 areaCode
        cityId: "", // 市区 id（region），用于取 city name
        isSigned: "", // 0未签约 1签约 2意向签约
        schoolType: "", // 1大学 4高中
        schoolName: "", // 模糊
        pageNum: 1,
        pageSize: 20,
      },
      listData: [],
      totalCount: 0,
      provinceOptions: [],
      allCityOptions: [], // 全国市区全量（level=2 不传 parentId）
      cityOptions: [], // 按省份过滤后的市区下拉
      provinceCodeMap: {}, // 省编码 -> 省名（列表回显）
      cityCodeMap: {}, // 市区编码 -> 市区名（列表回显）
      provinceIdMap: {}, // 省 id -> 编码（请求 areaCode）
      cityIdMap: {}, // 市区 id -> 编码（请求 city）
      loading: false,
      exporting: false,
    };
  },
  methods: {
    // 组装请求体 AdminSportsMeetQueryModel
    buildQueryBody(includePage) {
      const body = {};
      if (includePage !== false) {
        body.pageNum = this.queryParam.pageNum;
        body.pageSize = this.queryParam.pageSize;
      }
      if (this.queryParam.provinceId) {
        body.areaCode = this.provinceIdMap[this.queryParam.provinceId] || "";
      }
      if (this.queryParam.cityId) {
        // 后端 city 字段要求传市区编码
        body.city = this.cityIdMap[this.queryParam.cityId] || "";
      }
      if (this.queryParam.isSigned !== "" && this.queryParam.isSigned != null) {
        body.isSigned = this.queryParam.isSigned;
      }
      if (
        this.queryParam.schoolType !== "" &&
        this.queryParam.schoolType != null
      ) {
        body.schoolType = this.queryParam.schoolType;
      }
      if (this.queryParam.schoolName) {
        body.schoolName = this.queryParam.schoolName;
      }
      return body;
    },

    // 拉省份（region level=1）
    fetchProvinces() {
      this.$http({
        url: this.$util.domain + "/adminapi/region/70310/search",
        method: "POST",
        body: JSON.stringify({ level: 1, pageNum: 1, pageSize: 9999 }),
      })
        .then((res) => {
          const resp = res.data || res.body;
          const list = (resp && resp.data && resp.data.list) || [];
          this.provinceOptions = list;
          this.provinceCodeMap = {};
          this.provinceIdMap = {};
          list.forEach((p) => {
            this.provinceCodeMap[p.code] = p.name;
            this.provinceIdMap[p.id] = p.code;
          });
          // 省份就绪后再拉全国市区，建编码->中文映射（保证 cityCodeMap 被填充）
          this.fetchAllCities();
        })
        .catch(() => {
          this.provinceOptions = [];
        });
    },

    // 拉全国市区：逐省份 level=2（parentId=省份id），合并建编码->中文映射。
    // 说明：region 接口 level=2 不传 parentId 时实际可能返回空，故逐省份拉取更稳妥。
    fetchAllCities() {
      const provinces = this.provinceOptions || [];
      if (!provinces.length) {
        this.allCityOptions = [];
        return;
      }
      const tasks = provinces.map((p) =>
        this.$http({
          url: this.$util.domain + "/adminapi/region/70310/search",
          method: "POST",
          body: JSON.stringify({
            parentId: p.id,
            level: 2,
            pageNum: 1,
            pageSize: 9999,
          }),
        })
          .then((res) => {
            const resp = res.data || res.body;
            return (resp && resp.data && resp.data.list) || [];
          })
          .catch(() => [])
      );
      Promise.all(tasks)
        .then((lists) => {
          const all = [];
          lists.forEach((l) => {
            if (l && l.length) all.push.apply(all, l);
          });
          this.allCityOptions = all;
          this.cityCodeMap = {};
          this.cityIdMap = {};
          all.forEach((c) => {
            this.cityCodeMap[c.code] = c.name;
            this.cityIdMap[c.id] = c.code;
          });
        })
        .catch(() => {
          this.allCityOptions = [];
        });
    },

    // 时间戳转 yyyy-MM-dd HH:mm:ss（兼容秒级/毫秒级）
    formatTimestamp(val) {
      if (val == null || val === "") return "--";
      const num = typeof val === "number" ? val : Number(val);
      if (isNaN(num)) return val; // 已经是可读字符串则原样返回
      const ts = val.toString().length <= 10 ? num * 1000 : num;
      const d = new Date(ts);
      if (isNaN(d.getTime())) return val;
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },

    onProvinceChange(val) {
      this.queryParam.cityId = "";
      // 下拉本地按省份过滤（allCityOptions 已含全国数据）
      this.cityOptions = val
        ? this.allCityOptions.filter((c) => c.parentId === val)
        : [];
    },

    queryList() {
      this.loading = true;
      this.$http({
        url: this.$util.domain + "/adminapi/sportsmeet/list",
        method: "POST",
        body: JSON.stringify(this.buildQueryBody(true)),
      })
        .then((res) => {
          const resp = res.data || res.body;
          if (resp && resp.error === 10000) {
            const data = resp.data || {};
            this.listData = data.list || [];
            this.totalCount = data.totalCount || 0;
          } else {
            this.$util.errorMsg((resp && resp.message) || "查询失败");
            this.listData = [];
            this.totalCount = 0;
          }
        })
        .catch((err) => {
          this.$util.errorMsg((err && err.message) || "查询失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      this.queryParam = {
        provinceId: "",
        cityId: "",
        isSigned: "",
        schoolType: "",
        schoolName: "",
        pageNum: 1,
        pageSize: 20,
      };
      this.cityOptions = [];
      this.queryList();
    },

    changeCurrentPage(pageNum) {
      this.queryParam.pageNum = Number(pageNum) || 1;
      this.queryList();
    },

    // 导出：同筛选条件全量，返回文件流
    exportExcel() {
      this.exporting = true;
      this.$http({
        url: this.$util.domain + "/adminapi/sportsmeet/export",
        method: "POST",
        responseType: "blob",
        body: JSON.stringify(this.buildQueryBody(false)),
      })
        .then((res) => {
          if (res && res.data instanceof Blob) {
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(res.data);
            downloadElement.href = href;
            downloadElement.download =
              "运动会统计_" + new Date().format("yyyyMMdd_hhmmss") + ".xlsx";
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          } else {
            this.$util.errorMsg("导出失败");
          }
        })
        .catch(() => {
          this.$util.errorMsg("导出失败");
        })
        .finally(() => {
          this.exporting = false;
        });
    },
  },
  mounted() {
    this.fetchProvinces(); // 内部链拉全国市区，建省市编码->中文映射
    this.queryList();
  },
};
</script>

<style scoped>
.breadcrumb {
  padding: 12px 15px;
  font-size: 13px;
  color: #666;
}
.breadcrumb .sep {
  margin: 0 6px;
  color: #c0c4cc;
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.export-btn {
  margin-left: auto;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// SportsStatistic.vue?b48e414a